module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"text":"Do you really want to reject this case?","buttons":{"confirm":"Approve the case and confirm the dates","ok":"OK"}}}')
  delete Component.options._Ctor
}
